import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
